




























import moment from 'moment-timezone';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { BaseVue } from '@/BaseVue';
import UiAlert from '@/components/ui/UiAlert.vue';
import UiButton from '@/components/ui/UiButton.vue';
import UiDatePicker from '@/components/ui/UiDatePicker.vue';

import { ApiSvcInventoryView } from '../../../../generated/api-svc';

@Component({
  components: {
    UiDatePicker,
    UiButton,
    UiAlert,
  },
})
export default class RolledUpActionsJeSync extends BaseVue {
  @Prop({ default: null })
  public readonly view!: ApiSvcInventoryView | null;

  public startDate = moment.tz(moment.tz.guess()).subtract(1, 'day').format('YYYY-MM-DD');
  public endDate = moment.tz(moment.tz.guess()).subtract(1, 'day').format('YYYY-MM-DD');
  public syncLoading = false;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;

  async syncToErp() {
    if (this.view && this.view.id) {
      this.syncLoading = true;
      this.errorMessage = null;
      this.successMessage = null;

      try {
        // TODO: Replace with actual API call when backend endpoint is ready
        // const svc = new InventoryApi(undefined, baConfig.getFriendlyApiUrl());
        // const response = await svc.syncRolledUpJournalEntries(
        //   this.orgId,
        //   this.view.id,
        //   this.startDate,
        //   this.endDate,
        //   {
        //     withCredentials: true,
        //   }
        // );

        // Placeholder - simulate API call
        await new Promise((resolve) => setTimeout(resolve, 1000));

        this.successMessage = 'Successfully synced journal entries to ERP';
      } catch (error: any) {
        console.error('Error syncing to ERP:', error);
        this.errorMessage = error?.response?.data?.message || 'Failed to sync journal entries to ERP';
      } finally {
        this.syncLoading = false;
      }
    }
  }
}
